import Vue from "vue";

Vue.prototype.$sottopiede = [
  {
    key: "sottopiede0"
  },
  {
    key: "sottopiede1"
  },
  {
    key: "sottopiede2"
  },
  {
    key: "sottopiede3"
  },
  {
    key: "sottopiede4"
  },
  {
    key: "sottopiede5"
  },
  {
    key: "sottopiede6"
  },
  {
    key: "sottopiede7"
  }
];
